import { Related, ResourceBase } from '../../resource-types';
import { RawModel } from '../schema';

export type InvoiceStatus =
  | 'draft'
  | 'open'
  | 'paid'
  | 'uncollectible'
  | 'void'
  | 'unknown';

export interface Invoice extends ResourceBase {
  status: InvoiceStatus;
  currency: 'eur';
  amount_due: number;
  amount_paid: number;
  total: number;
  /** Stripe-hosted invoice page */
  invoice_url: string;
  invoice_pdf: string;
  relationships: {
    workspace: Related<'workspace'>;
  };
}

export const invoice: RawModel = {
  type: 'invoice',
  plural: 'invoices',
  JSONApi: true,
  useWorker: true,
  attributes: {
    id: 'UUID',
    display_name: 'string',
    invoice_url: 'https://invoice.stripe.com/i/...',
    invoice_pdf: 'https://pay.stripe.com/invoice/.../pdf'
  },
  relationships: {
    workspace: {
      type: 'workspace',
      binding: ['one', 'many'],
      reverse: 'invoice'
    }
  }
};
